import Rest from '../Services/Rest'

/**
 * @typedef {WorkService}
 */
export default class WorkService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/work'

   /**
   * @param {Object} record
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  salvar (record) {    
    return this.post('/save', record)
  }

  
   /**
   * @param {Object} record
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  getOne (id){
    return this.get(`/${id}`)    
  }


  /**
   * @param {Object} parameters
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  search (parameters = {}) {
    var queryString = ''
    // apply your logic here
    if( Object.keys(parameters).length ){
      var _p = [];
      
      Object.keys(parameters).map(function(key,index){
        _p.push( key+"="+parameters[key] );
      });
      queryString = "?"+ _p.join("&");
    }
    return this.get(`/all${queryString}`).then(response => ({
      items: response.items // just an example
    }))
  }

}